import moment from 'moment-timezone';

export default class FYearService {

    // Get Financial Year
    static getFYear = () => {
        let year =
            moment().tz("Asia/Kolkata").month() + 1 <= 3
                ? moment().tz("Asia/Kolkata").year() - 1
                : moment().tz("Asia/Kolkata").year();
        const currentFinancialYear = `${year}-${`${year + 1}`.slice(2, 4)}`;
        const prevFinancialYear = `${year - 1}-${`${year}`.slice(2, 4)}`;
        // const next3FinancialYear = [
        //     `${year + 1}-${`${year + 2}`.slice(2, 4)}`,
        //     `${year + 2}-${`${year + 3}`.slice(2, 4)}`,
        //     `${year + 3}-${`${year + 4}`.slice(2, 4)}`,
        // ]
        const next3FinancialYear = [
            `${year}-${`${year + 1}`.slice(2, 4)}`,
            `${year + 1}-${`${year + 2}`.slice(2, 4)}`,
            `${year + 2}-${`${year + 3}`.slice(2, 4)}`,
        ]
        return {
            currentFinancialYear,
            prevFinancialYear,
            next3FinancialYear,
        };
    }

}